import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatControlsModule } from '../MatControls.module';
import { NewCreateRequestComponent } from './new-create-request.component';

@NgModule({
  declarations: [
    NewCreateRequestComponent,
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatControlsModule,
  ],
  exports: [
    NewCreateRequestComponent,
  ],
})
export class NewCreateRequestModule { }
